import { Modal } from "react-bootstrap";
import Cancelimg from "../../assets/img/cancel-01.svg";
import UserIcon from "../../assets/img/user-icon.svg";
import VectorIcon from "../../assets/img/VectorIcon1.svg";
import useTranslator from "../../hooks/useTranslator";
import { useNavigate, useParams } from "react-router-dom";
import { haveValue } from "../../helper/common";
import { useContext } from "react";
import AuthContext from "../../context/auth/AuthContext";

const LinkedTenantsProperties = ({
  propertiesData,
  showPropertiesPopup,
  setShowPropertiesPopup,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { workspaceId } = useParams();

  return (
    <>
      <Modal
        show={showPropertiesPopup}
        onHide={(e) => setShowPropertiesPopup(false)}
        centered
        close
        className="newmodalui wrapper-modal inviteTenantModal max-w-lg awardPropertyModal text-center"
      >
        <Modal.Header>
          <Modal.Title>{_t("tenantLinkedProperties")}</Modal.Title>
          <div
            className="cursor-pointer"
            onClick={() => setShowPropertiesPopup(false)}
          >
            <img
              src={Cancelimg}
              alt="icon"
              className="canceicon topRightIcon"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <ul className="mt-0 awardPropertyList">
            {propertiesData?.map((property) => {
              const propertyName = `${property?.street} - ${
                Number.isNaN(parseInt(property?.street_number, 10))
                  ? "N/A"
                  : String(parseInt(property?.street_number, 10))
              }, ${property?.floor_number}${
                property?.flat_number ? ` - ${property?.flat_number}` : ""
              }`;
              return (
                <li
                  className="cursor-pointer"
                  onClick={() =>
                    navigate(
                      user?.role === "landlord" && haveValue(workspaceId)
                        ? `/${workspaceId}/home?propertyId=${property?._id}&propName=${propertyName}`
                        : `/home?propertyId=${property?._id}&propName=${propertyName}`
                    )
                  }
                >
                  <div className="earner-thumbnail-wrapper d-flex align-items-center justify-content-center">
                    <img src={UserIcon} alt="User Icon" />
                  </div>
                  {propertyName}
                  <div className="ms-auto">
                    <img
                      className="Imagerutate ImageSizeSet ms-1"
                      src={VectorIcon}
                      alt="Vector Icon"
                    />
                  </div>
                </li>
              );
            })}
          </ul>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LinkedTenantsProperties;
